"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const web3_1 = require("@alephium/web3");
(0, web3_1.assertType)();
(0, web3_1.assertType)();
//# sourceMappingURL=types.js.map